import Bank from './bank.svg'
import Bell from './bell.svg'
import Calendar from './calendar.svg'
import CheckCircle from './checkcircle.svg'
import Cog from './cog.svg'
import Ellipsis from './ellipsis.svg'
import Euro from './euro.svg'
import GraphFile from './graph-file.svg'
import House from './house.svg'
import LeaverDoor from './leaver-door.svg'
import MoneyFile from './money-file.svg'
import PoundCircle from './pound-circle.svg'
import CalendarCheck from './calendarcheck.svg'
import ConversationQuestion from './conversationquestion.svg'
import Document1 from './document1.svg'
import PaymentScreen from './paymentscreen.svg'
import Edit from './edit.svg'
import Save from './save.svg'
import Delete from './delete.svg'
import Filter from './filter.svg'
import BenefitInKind from './benefit-in-kind.svg'
import CompanyBuilding from './company-building.svg'
import Delegation from './delegation.svg'
import Form from './form.svg'
import OnlinePayment from './online-payment.svg'
import PaymentsAndDeductions from './payments-and-deductions.svg'
import Subcontractor from './subcontractor.svg'
import Pension from './pension.svg'
import PayrollConfig from './payrollconfig.svg'




export const icons = {
  bank: Bank,
  checkcircle: CheckCircle,
  bell: Bell,
  calendar: Calendar,
  cog: Cog,
  ellipsis: Ellipsis,
  euro: Euro,
  graphfile: GraphFile,
  house: House,
  leaverdoor: LeaverDoor,
  moneyfile: MoneyFile,
  poundcircle: PoundCircle,
  calendarcheck: CalendarCheck,
  conversationquestion: ConversationQuestion,
  document1: Document1,
  paymentscreen: PaymentScreen,
  edit: Edit,
  save: Save,
  delete: Delete,
  filter: Filter,
  benefit: BenefitInKind,
  companybuilding: CompanyBuilding,
  delegation: Delegation,
  form: Form,
  onlinepayment: OnlinePayment,
  paymentsanddeductions: PaymentsAndDeductions,
  subcontractor: Subcontractor,
  pension: Pension,
  payrollconfig: PayrollConfig
}